module.exports = __webpack_public_path__ + "static/media/gMask-desktop.a71d251f.png";